// 后台菜单栏
const sideOptions = [
  {
    title: '个人中心',
    key: 'info',
    icon: 'user',
    child: [
      { title: '用户信息', key: 'personal', toRouter: '/index/personal/user' }
    ]
  }
]
// 设置这种格式保证点击菜单栏能被选中
const nameMap = {
  personal: ['info', 'personal']
}

// 在主页面中添加子页面(添加,编辑页面) 防止刷新后菜单栏选中错误
const childMap = []

module.exports = {
  sideOptions,
  // 映射表
  nameMap,
  childMap
}
